<template>
  <div class="home-business-group">
    <div class="text-group">
      <h3 class="text-accent">{{ $t('kcm-group') }}</h3>
      <h1>{{ $t('home-bg-2') }}</h1>
      <h2>{{ $t('home-bg-3') }}</h2>
      <router-link to="/kcm-group?page=companies" class="link desktop">
        <span class="text-main-home">{{ $t('learn-more') }}</span>
      </router-link>
    </div>
    <img src="../../assets/img/home/business_group/business_group.png" alt="Photo">
    <div class="text-group mobile">
      <router-link to="/kcm-group?page=companies" class="link">
        <span class="text-main-home">{{ $t('learn-more') }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.home-business-group {
  @extend %flex-center;
  background-color: #b2c8d2;
  justify-content: space-between;
  padding: 0 $sidesPadding;
  img {
    width: 50%;
    @include transform(scale(1.2));
    position: relative;
    right: 5%;
  }
  .text-group {
    width: 40%;
    padding-right: 50px;
  }
  .mobile {
    display: none;
  }
}
@media screen and (max-width: 1600px) {
  .home-business-group {
    padding: 0 $sidesPadding1600;
  }
}
@media screen and (max-width: 1366px) {
  .home-business-group {
    .text-group {
      padding-top: 50px;
      padding-bottom: 50px;
    }
  }
}
@media screen and (max-width: 1280px) {
  .home-business-group {
    padding: 0 $sidesPadding1280;
  }
}
@media screen and (max-width: 800px) {
  .home-business-group {
    flex-direction: column;
    padding: 0;
    .desktop {
      display: none;
    }
    .mobile {
      display: block;
    }
    .text-group {
      width: 100%;
      padding: $sidesPadding1280;
    }
    img {
      width: 100%;
      right: initial;
      @include transform(initial);
    }
  }
}
@media screen and (max-width: 600px) {
  .home-business-group {
    .text-group {
      width: 100%;
      padding: $sidesPadding600;
    }
  }
}
</style>

